'use client';

import type { QuickFilterItem } from '@weberus/shared-types';
import { RectangleButton, DotBadge } from '@yanolja-rnd/nol-design-system';
import { IcSorting, IcFilter } from '@yanolja-rnd/nol-icons';
import { InView } from 'react-intersection-observer';
import { FILTER_LABEL, SORT_LABEL } from '@/app/(pages)/results/constants';
import { QuickFilterChips } from '@/app/(pages)/results/(pages)/ui/search-header/quick-filter-chips';
import { cn } from '@/app/_shared/utils/tw-cn';

export interface LeisureFilterProps {
  fixedAreaRef: (el: HTMLDivElement | null) => void;
  hasQuickFilter: boolean;
  isFilterSelected: boolean;
  isSortSelected: boolean;
  onClickGlobalFilter?: () => void;
  onClickSort?: () => void;
  onClickChip: (item: QuickFilterItem) => void;
  onImpressionChip?: (item: QuickFilterItem & Partial<{ isGlobalFilter: boolean }>) => void;
  onImpressionSort?: () => void;
}

export const LeisureFilter = (props: LeisureFilterProps) => {
  const {
    fixedAreaRef,
    hasQuickFilter,
    isFilterSelected,
    isSortSelected,
    onClickGlobalFilter,
    onClickSort,
    onClickChip,
    onImpressionChip,
    onImpressionSort,
  } = props;

  return (
    <div className="mx-auto max-w-legacy-pc-size z-middle">
      <div
        ref={fixedAreaRef}
        className={cn('mr-16 flex h-62 items-center justify-between bg-static-white pb-10 pt-12', {
          'mx-16': !hasQuickFilter,
        })}>
        {/* 퀵 필터 */}
        {hasQuickFilter && (
          <div className="flex min-w-[174px]">
            <QuickFilterChips onClickChip={onClickChip} onImpressionChip={onImpressionChip} />
          </div>
        )}
        {/* 필터 및 정렬 버튼 */}
        <div className={cn('flex justify-end', { 'w-full': !hasQuickFilter })}>
          <div className="relative z-[1] flex w-full gap-4 bg-static-white">
            {hasQuickFilter && (
              <div className="absolute left-[-30px] top-0 z-[1] h-full w-30 bg-[linear-gradient(90deg,_rgba(255,255,255,0)_0%,_#ffffff_85%)]" />
            )}
            <div className="relative flex-1">
              <RectangleButton
                icon={<IcFilter />}
                theme="outlined_basic"
                size="medium"
                weight="regular"
                showDotBadge={false}
                className={cn('min-w-69 px-12 pc:w-[181px]', { '!w-full': !hasQuickFilter })}
                isCapsule
                onClick={onClickGlobalFilter}>
                {FILTER_LABEL}
              </RectangleButton>
              {isFilterSelected && (
                <div className="absolute right-12 top-2 size-11 translate-x-full rounded-capsule bg-static-white">
                  <DotBadge className="relative right-[3.5px] top-2 size-6" />
                </div>
              )}
            </div>
            <InView
              as="div"
              className="relative flex-1"
              triggerOnce
              onChange={(inView) => inView && onImpressionSort?.()}>
              <RectangleButton
                icon={<IcSorting />}
                theme="outlined_basic"
                size="medium"
                weight="regular"
                showDotBadge={false}
                className={cn('min-w-69 px-12 pc:w-[181px]', { '!w-full': !hasQuickFilter })}
                isCapsule
                onClick={onClickSort}>
                {SORT_LABEL}
              </RectangleButton>
              {isSortSelected && (
                <div className="absolute right-12 top-2 size-11 translate-x-full rounded-capsule bg-static-white">
                  <DotBadge className="relative right-[3.5px] top-2 size-6" />
                </div>
              )}
            </InView>
          </div>
        </div>
      </div>
    </div>
  );
};
